/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Partial update: only the fields sent are changed; null clears league and season.
 * @export
 * @interface CompetitionUpdate
 */
export interface CompetitionUpdate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompetitionUpdate
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionUpdate
     */
    league_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionUpdate
     */
    season_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionUpdate
     */
    is_public?: boolean | null;
}

/**
 * Check if a given object implements the CompetitionUpdate interface.
 */
export function instanceOfCompetitionUpdate(value: object): value is CompetitionUpdate {
    return true;
}

export function CompetitionUpdateFromJSON(json: any): CompetitionUpdate {
    return CompetitionUpdateFromJSONTyped(json, false);
}

export function CompetitionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'league_id': json['league_id'] == null ? undefined : json['league_id'],
        'season_id': json['season_id'] == null ? undefined : json['season_id'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
    };
}

export function CompetitionUpdateToJSON(json: any): CompetitionUpdate {
    return CompetitionUpdateToJSONTyped(json, false);
}

export function CompetitionUpdateToJSONTyped(value?: CompetitionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'league_id': value['league_id'],
        'season_id': value['season_id'],
        'is_public': value['is_public'],
    };
}

